import { vnModule_knockoutJS } from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import {privacyPolicy_template} from '../components/templates/privacyPolicy_template';
import {header} from './header';

declare var ko: any;
declare var page: any;

export class privacy_policy extends vnModule_knockoutJS{

    protected privacyPolicy_template: privacyPolicy_template
    protected XHRHdl: XMLHttpRequestHandler;

    protected getModuleName(): string{

        return 'privacy_policy';
    }

    buildContent(): Array<Element>{

        this.privacyPolicy_template = new privacyPolicy_template('privacy_policy', this.viewModel, this);

        return [this.privacyPolicy_template.build()];
    }

    public fillPage(): void{
    }
}



// WEBPACK FOOTER //
// ./js/modules/privacy_policy.ts